/* COD Form v3 — CodStoreDz layout
   Sends orders to the Google Apps Script (same field names as v2), plus:
   wilaya dropdown, product subtotal, variants, gallery, sticky bars.
   Everything is inside one IIFE so nothing leaks into (or clashes with) the
   global scope of apps / other theme scripts. */
(function () {
  'use strict';

  var CFG = window.COD_CFG || {};
  var APPS_SCRIPT_URL = CFG.appsScriptUrl || window.APPS_SCRIPT_URL;
  var THANKYOU_URL = CFG.thankyouUrl || window.THANKYOU_URL || '/pages/thankyou';

  var form = document.forms['google-sheet'];
  var btn = document.getElementById('btnSubmitMain');
  if (!form || !btn) return;

  var $ = function (id) { return document.getElementById(id); };
  var phoneInput = $('SaPhone');
  var phoneMsg = $('phoneMessage');
  var wilayaEl = $('Wilaya');
  var btnHTML = btn.innerHTML;
  var initiallyAvailable = btn.getAttribute('data-initial-available') !== 'false';
  var formSubmitted = false, submissionConfirmed = false;
  var controlsBeforeSubmit = [];
  var activeOrder = null;

  function fmt(n) {
    // "2 900 دج" — NBSP thousands separator, wrapped in a bidi isolate so the
    // digit groups never swap places inside RTL text.
    var v = Math.round(Number(n) || 0);
    var LRI = String.fromCharCode(0x2066), PDI = String.fromCharCode(0x2069), NBSP = String.fromCharCode(0xA0);
    return LRI + String(v).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP) + PDI + ' دج';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /*********** State ***********/
  var unitPrice = parseFloat(($('SaUnitPrice') || {}).value) || 0;
  var comparePrice = 0;
  var currentQty = 1;
  var currentVariant = null;

  /*********** Auto-fill from URL params (retargeting links) ***********/
  (function autoFillFromURL() {
    try {
      var params = new URLSearchParams(window.location.search);
      var map = {
        name: 'Sa-Name', fname: 'Sa-Name', first_name: 'Sa-Name',
        phone: 'Sa-Phone', tel: 'Sa-Phone',
        wilaya: 'Sa-Wilaya', city: 'Sa-Wilaya',
        address: 'Sa-Address', addr: 'Sa-Address'
      };
      Object.keys(map).forEach(function (key) {
        var val = params.get(key);
        var el = form.elements[map[key]];
        if (!val || !el || el.value) return;
        if (el.tagName === 'SELECT') {
          for (var i = 0; i < el.options.length; i++) {
            if (el.options[i].value === val) { el.value = val; break; }
          }
        } else {
          el.value = val;
        }
      });
    } catch (e) {}
  })();

  /*********** Enter jumps to the next field ***********/
  (function smartFormFlow() {
    var inputs = form.querySelectorAll('input:not([type=hidden]):not([type=radio]):not([tabindex="-1"]), select');
    Array.prototype.forEach.call(inputs, function (el, idx) {
      el.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        var next = inputs[idx + 1];
        if (next) next.focus(); else btn.focus();
      });
    });
  })();

  /*********** Prices + special offers ***********/
  // An offer = pieces received (data-qty), pieces paid (data-paid) and an
  // optional fixed total (data-price, 0 = paid × current unit price).
  var currentOffer = null;
  function offerTotal(r) {
    var fixed = parseFloat(r.getAttribute('data-price')) || 0;
    return fixed > 0 ? fixed : unitPrice * (parseFloat(r.getAttribute('data-paid')) || 1);
  }
  function productTotal() {
    return currentOffer ? offerTotal(currentOffer) : unitPrice * currentQty;
  }

  function renderPrices() {
    var total = productTotal();
    $('SaUnitPrice').value = unitPrice;
    $('SaPrice').value = unitPrice;
    $('SaTotal').value = total;

    document.querySelectorAll('[data-cod-price]').forEach(function (el) { el.textContent = fmt(unitPrice); });
    var save = comparePrice > unitPrice ? comparePrice - unitPrice : 0;
    document.querySelectorAll('[data-cod-old-price]').forEach(function (el) {
      el.hidden = !save; el.textContent = fmt(comparePrice);
    });
    document.querySelectorAll('[data-cod-save]').forEach(function (el) {
      el.hidden = !save; el.textContent = 'وفّر ' + fmt(save);
    });
    // Offer prices follow the selected variant's price
    form.querySelectorAll('input[name="Sa-Offer"]').forEach(function (r) {
      var row = r.closest('.offer-row');
      var t = offerTotal(r);
      var full = unitPrice * (parseFloat(r.getAttribute('data-qty')) || 1);
      var p = row.querySelector('[data-offer-price]');
      var o = row.querySelector('[data-offer-old]');
      if (p) p.textContent = fmt(t);
      if (o) { o.hidden = !(full > t); o.textContent = fmt(full); }
      row.classList.toggle('selected', r.checked);
    });
    var sticky = document.querySelector('.sticky-price');
    if (sticky) sticky.textContent = fmt(total);
    if ($('codOrderQuantity')) $('codOrderQuantity').textContent = currentQty;
    if ($('codOrderSubtotal')) $('codOrderSubtotal').textContent = fmt(total);
  }

  /*********** Quantity: offers when enabled, otherwise the − / + stepper ***********/
  function setQty(n) {
    currentQty = Math.max(1, Math.min(20, n));
    if ($('qtyVal')) $('qtyVal').textContent = currentQty;
    $('hiddenQty').value = currentQty;
    $('hiddenOffer').value = currentQty;
    renderPrices();
  }
  document.querySelectorAll('[data-qty-action]').forEach(function (b) {
    b.addEventListener('click', function () {
      setQty(currentQty + (b.getAttribute('data-qty-action') === 'inc' ? 1 : -1));
    });
  });
  function applyOffer() {
    currentOffer = form.querySelector('input[name="Sa-Offer"]:checked');
    if (currentOffer) setQty(parseInt(currentOffer.getAttribute('data-qty'), 10) || 1);
    else renderPrices();
  }
  form.querySelectorAll('input[name="Sa-Offer"]').forEach(function (r) {
    r.addEventListener('change', applyOffer);
  });

  /*********** Gallery (native scroll-snap swipe + thumbs + arrows) ***********/
  var slider = $('codSlider');
  var slides = slider ? slider.querySelectorAll('.cod-slide') : [];
  var activeSlide = 0;
  function goToSlide(i) {
    if (!slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    // offsetLeft works in both LTR and RTL; scrollLeft sign differs in RTL, so
    // scroll the slide into view horizontally only (never jumps the page).
    var target = slides[i];
    var sRect = slider.getBoundingClientRect();
    var tRect = target.getBoundingClientRect();
    slider.scrollBy({ left: tRect.left - sRect.left, behavior: 'smooth' });
  }
  function markSlide(i) {
    activeSlide = i;
    var count = $('codCount');
    if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    document.querySelectorAll('.cod-thumb').forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
  }
  if (slider && slides.length > 1) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) markSlide(Number(en.target.getAttribute('data-index')) || 0);
        });
      }, { root: slider, threshold: 0.6 });
      slides.forEach(function (s) { io.observe(s); });
    }
    document.querySelectorAll('.cod-thumb').forEach(function (t) {
      t.addEventListener('click', function () { goToSlide(Number(t.getAttribute('data-index')) || 0); });
    });
    document.querySelectorAll('[data-cod-nav]').forEach(function (b) {
      b.addEventListener('click', function () { goToSlide(activeSlide + Number(b.getAttribute('data-cod-nav'))); });
    });
    // Pause any playing video when it is swiped away
    slider.addEventListener('scroll', function () {
      slider.querySelectorAll('video').forEach(function (v) { if (!v.paused) v.pause(); });
    }, { passive: true });
  }
  function goToMedia(mediaId) {
    if (!mediaId || !slider) return;
    var s = slider.querySelector('.cod-slide[data-media-id="' + mediaId + '"]');
    if (s) goToSlide(Number(s.getAttribute('data-index')) || 0);
  }

  /*********** Variants ***********/
  var variants = [];
  try { variants = JSON.parse(($('codVariants') || {}).textContent || '[]'); } catch (e) {}
  function selectedOptions() {
    var out = [];
    form.querySelectorAll('input[type=radio][data-option-index]:checked').forEach(function (r) {
      out[Number(r.getAttribute('data-option-index'))] = r.value;
    });
    return out;
  }
  function updateVariant(fromUser) {
    if (!variants.length) return;
    var opts = selectedOptions();
    var v = null;
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var k = 0; k < opts.length; k++) { if (opts[k] != null && variants[i].options[k] !== opts[k]) { ok = false; break; } }
      if (ok) { v = variants[i]; break; }
    }
    opts.forEach(function (val, k) {
      var lbl = form.querySelector('[data-option-label="' + k + '"]');
      if (lbl) lbl.textContent = val;
    });
    currentVariant = v;
    $('SaVariant').value = v ? v.title : opts.join(' / ');
    $('SaVariantId').value = v ? v.id : '';
    if (v) { unitPrice = v.price; comparePrice = v.compare; }
    var soldOut = !v || !v.available;
    btn.disabled = soldOut || formSubmitted || form.dataset.codReady !== 'true';
    btn.classList.toggle('is-soldout', soldOut);
    if (!formSubmitted) btn.innerHTML = soldOut ? '<span class="btn-text"><span>' + (v ? 'نفذ هذا الخيار — اختر خياراً آخر' : 'هذا الخيار غير متوفر') + '</span></span>' : btnHTML;
    var availability = $('variantAvailability');
    if (availability) {
      availability.hidden = !soldOut;
      availability.textContent = soldOut ? 'هذا الاختيار غير متوفر حالياً. اختر لوناً أو مقاساً آخر.' : '';
    }
    // Mark values incompatible with the selected options, but keep them
    // selectable so customers can reach combinations requiring two changes.
    form.querySelectorAll('input[type=radio][data-option-index]').forEach(function (r) {
      var index = Number(r.getAttribute('data-option-index'));
      var available = variants.some(function (candidate) {
        return candidate.available && candidate.options[index] === r.value && opts.every(function (value, k) {
          return k === index || value == null || candidate.options[k] === value;
        });
      });
      var label = r.closest('label');
      if (label) label.classList.toggle('is-soldout', !available);
      r.setAttribute('aria-label', r.value + (available ? '' : ' — غير متوفر مع الاختيارات الحالية'));
    });
    renderPrices();
    if (fromUser && v && v.media) goToMedia(v.media);
  }
  if (variants.length) {
    var first = variants.filter(function (v) { return String(v.id) === String($('SaVariantId').value); })[0];
    if (first) { comparePrice = first.compare; currentVariant = first; }
    form.querySelectorAll('input[type=radio][data-option-index]').forEach(function (r) {
      r.addEventListener('change', function () { updateVariant(true); });
    });
    // Grey out option values that have no available variant at all
    form.querySelectorAll('input[type=radio][data-option-index]').forEach(function (r) {
      var k = Number(r.getAttribute('data-option-index'));
      var any = variants.some(function (v) { return v.available && v.options[k] === r.value; });
      if (!any) r.closest('label').classList.add('is-soldout');
    });
    updateVariant(false);
  } else {
    var oldEl = document.querySelector('[data-cod-old-price]');
    if (oldEl && !oldEl.hidden) comparePrice = parseFloat(oldEl.textContent.replace(/[^\d]/g, '')) || 0;
  }
  applyOffer();
  if (wilayaEl) wilayaEl.addEventListener('change', function () {
    wilayaEl.classList.toggle('is-invalid', !wilayaEl.value);
  });

  /*********** Phone — Algerian validation ***********/
  function extractDigits(str) {
    // Arabic-Indic / Persian digits → ASCII (common on Arabic keyboards)
    var d = String(str || '').replace(/[٠-٩]/g, function (c) { return c.charCodeAt(0) - 0x660; })
      .replace(/[۰-۹]/g, function (c) { return c.charCodeAt(0) - 0x6F0; })
      .replace(/\D/g, '');
    if (d.indexOf('00213') === 0) d = d.substring(5);
    else if (d.indexOf('213') === 0 && d.length >= 11) d = d.substring(3);
    if (d.length === 9 && /^[567]/.test(d)) d = '0' + d;
    return d;
  }
  function isValidAlgerianPhone(d) { return /^0[567]\d{8}$/.test(d); }
  function showPhoneMsg(text, ok) {
    if (!phoneMsg) return;
    phoneMsg.textContent = text;
    phoneMsg.classList.toggle('is-show', !!text);
    phoneMsg.classList.toggle('is-ok', !!ok);
  }
  function updatePhoneUI(strict) {
    var digits = extractDigits(phoneInput.value);
    $('SaPhoneDigits').value = digits;
    phoneInput.classList.remove('is-valid', 'is-invalid');
    phoneInput.removeAttribute('aria-invalid');
    if (!digits.length) { showPhoneMsg(strict ? '⚠️ أدخل رقم هاتفك ليتصل بك فريقنا' : ''); if (strict) { phoneInput.classList.add('is-invalid'); phoneInput.setAttribute('aria-invalid', 'true'); } return; }
    if (isValidAlgerianPhone(digits)) {
      phoneInput.classList.add('is-valid');
      showPhoneMsg('✓ رقم صحيح', true);
    } else if (digits.length < 10 && !strict) {
      showPhoneMsg('');
    } else {
      phoneInput.classList.add('is-invalid');
      phoneInput.setAttribute('aria-invalid', 'true');
      showPhoneMsg(digits.length < 10 ? '⚠️ الرقم ناقص — يجب أن يكون 10 أرقام' : '⚠️ رقم غير صحيح — يبدأ بـ 05 أو 06 أو 07 ويتكوّن من 10 أرقام');
    }
  }
  function hasPhoneForSending() {
    var digits = extractDigits(phoneInput.value);
    $('SaPhoneDigits').value = digits;
    return isValidAlgerianPhone(digits);
  }
  phoneInput.addEventListener('input', function () { updatePhoneUI(false); });
  phoneInput.addEventListener('blur', function () { if (phoneInput.value.trim()) updatePhoneUI(true); });

  /*********** IDs ***********/
  function safeUUID() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'id_' + Math.random().toString(36).slice(2) + '_' + Date.now().toString(36);
  }
  var SESSION_ID = (function () {
    try {
      var sid = sessionStorage.getItem('sa_session_id_v1');
      if (!sid) { sid = safeUUID(); sessionStorage.setItem('sa_session_id_v1', sid); }
      return sid;
    } catch (e) { return safeUUID(); }
  })();
  $('saSessionId').value = SESSION_ID;

  /*********** Date + page URL + GCLID/WBRAID/GBRAID (offline conversions) ***********/
  (function initDateTimeAndSource() {
    var p = function (n) { return String(n).padStart(2, '0'); };
    var now = new Date();
    $('datetime').value = now.getFullYear() + '-' + p(now.getMonth() + 1) + '-' + p(now.getDate()) + ' ' + p(now.getHours()) + ':' + p(now.getMinutes()) + ':' + p(now.getSeconds());
    $('campaignUrl').value = window.location.href;
    var params = new URLSearchParams(window.location.search || '');
    var gclid = params.get('gclid') || params.get('gclid_aw') || params.get('gcl_aw') || '';
    if (!gclid) gclid = params.get('wbraid') || params.get('gbraid') || '';
    $('gclid').value = gclid;
  })();

  /*********** Behaviour metrics (sent to the sheet only) ***********/
  var pageLoadTime = Date.now();
  var lastInteraction = Date.now();
  var mouseMoveCount = 0, mouseTotalDistance = 0, lastMouseX = null, lastMouseY = null;
  var scrollCount = 0, scrollTotalDistance = 0, scrollMaxDepth = 0;
  var lastScrollY = window.scrollY || 0, lastScrollTime = Date.now(), scrollLongestPause = 0;
  var focusCount = 1;

  var ua = (navigator.userAgent || '').toLowerCase();
  var viewportW = window.innerWidth || document.documentElement.clientWidth;
  var viewportH = window.innerHeight || document.documentElement.clientHeight;
  var deviceType = (/mobile|android|iphone|ipod/.test(ua) || viewportW <= 768) ? 'mobile'
    : ((/ipad|tablet/.test(ua) || viewportW <= 1024) ? 'tablet' : 'desktop');
  var networkType = (navigator.connection && navigator.connection.effectiveType) || '';

  ['input', 'change', 'click', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, function () { lastInteraction = Date.now(); }, { capture: true, passive: true });
  });
  document.addEventListener('mousemove', function (e) {
    mouseMoveCount++;
    if (lastMouseX !== null) mouseTotalDistance += Math.sqrt(Math.pow(e.clientX - lastMouseX, 2) + Math.pow(e.clientY - lastMouseY, 2));
    lastMouseX = e.clientX; lastMouseY = e.clientY;
    lastInteraction = Date.now();
  }, { passive: true });
  window.addEventListener('scroll', function () {
    scrollCount++;
    lastInteraction = Date.now();
    var y = window.scrollY || 0;
    var max = document.documentElement.scrollHeight - viewportH;
    if (max > 0 && y / max > scrollMaxDepth) scrollMaxDepth = y / max;
    var now = Date.now();
    if (now - lastScrollTime > scrollLongestPause) scrollLongestPause = now - lastScrollTime;
    lastScrollTime = now;
    scrollTotalDistance += Math.abs(y - lastScrollY);
    lastScrollY = y;
  }, { passive: true });

  function getBehaviorMetrics() {
    return {
      'Sa-Time-Stay': String(Math.round((Date.now() - pageLoadTime) / 1000)),
      'Sa-Mouse-Move-Count': String(mouseMoveCount),
      'Sa-Mouse-Total-Distance': String(Math.round(mouseTotalDistance)),
      'Sa-Scroll-Count': String(scrollCount),
      'Sa-Scroll-Total-Distance': String(scrollTotalDistance),
      'Sa-Scroll-Max-Depth': scrollMaxDepth.toFixed(2),
      'Sa-Scroll-Longest-Pause': String(scrollLongestPause),
      'Sa-Scroll-Avg-Speed': String(scrollCount ? Math.round(scrollTotalDistance / scrollCount) : 0),
      'Sa-Device-Type': deviceType,
      'Sa-Viewport-W': String(viewportW),
      'Sa-Viewport-H': String(viewportH),
      'Sa-Screen-W': String((window.screen && screen.width) || viewportW),
      'Sa-Screen-H': String((window.screen && screen.height) || viewportH),
      'Sa-DPR': String(window.devicePixelRatio || 1),
      'Sa-Browser-Lang': navigator.language || '',
      'Sa-User-Agent': navigator.userAgent || '',
      'Sa-Network-Type': networkType,
      'Sa-Focus-Count': String(focusCount)
    };
  }

  /*********** FormData ***********/
  function buildFD(stage) {
    renderPrices();
    var fd = new FormData(form);
    fd.set('Sa-Lead-Stage', stage);
    $('leadStage').value = stage;
    var eventId = safeUUID();
    fd.set('Sa-Session-Id', SESSION_ID);
    fd.set('Sa-Event-Id', eventId);
    $('saEventId').value = eventId;
    fd.set('Sa-Phone-Digits', extractDigits(phoneInput.value));
    fd.set('Quantity', String(currentQty));
    fd.set('Offer', String(currentQty));
    var metrics = getBehaviorMetrics();
    Object.keys(metrics).forEach(function (k) { fd.set(k, metrics[k]); });
    $('timeStay').value = metrics['Sa-Time-Stay'];
    fd.set('Sa-Client-ISOTime', new Date().toISOString());
    fd.delete('Sa-Bot-Trap');
    return fd;
  }
  function fdToURLEncoded(fd) {
    var params = new URLSearchParams();
    fd.forEach(function (v, k) { params.append(k, v); });
    return params.toString();
  }

  /*********** Background sends (Draft / Attempted / Abandoned) ***********/
  function sendViaBeaconOrKeepalive(fd) {
    try {
      var body = fdToURLEncoded(fd);
      if (navigator.sendBeacon) {
        if (navigator.sendBeacon(APPS_SCRIPT_URL, new Blob([body], { type: 'application/x-www-form-urlencoded' }))) return true;
      }
      fetch(APPS_SCRIPT_URL, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body, keepalive: true }).catch(function () {});
      return true;
    } catch (e) { return false; }
  }

  /*********** Durable pending orders ***********/
  // One key per event prevents a successful order from erasing another order
  // for the same customer. Keep unacknowledged orders; never truncate the queue.
  var QUEUE_PREFIX = 'sa_pending_order_v2:';
  var memoryOrders = Object.create(null);
  var confirmedOrders = Object.create(null);
  var inFlightOrders = Object.create(null);
  var REQUEST_TIMEOUT = 15000;
  var recoveryOrder = null;
  function validRecord(record) {
    return record && record.endpoint === APPS_SCRIPT_URL && record.payload &&
      record.payload['Sa-Lead-Stage'] === 'Submitted' &&
      /^[a-zA-Z0-9_-]{1,180}$/.test(record.payload['Sa-Event-Id'] || '');
  }
  function saveRecord(record) {
    var id = record.payload['Sa-Event-Id'];
    memoryOrders[id] = record;
    try { localStorage.setItem(QUEUE_PREFIX + id, JSON.stringify(record)); return true; }
    catch (e) { return false; }
  }
  function getQueue() {
    var records = Object.create(null);
    Object.keys(memoryOrders).forEach(function (id) { records[id] = memoryOrders[id]; });
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (!key || key.indexOf(QUEUE_PREFIX) !== 0) continue;
        try {
          var record = JSON.parse(localStorage.getItem(key));
          if (validRecord(record)) records[record.payload['Sa-Event-Id']] = record;
        } catch (e) {}
      }
    } catch (e) {}
    return Object.keys(records).map(function (id) { return records[id]; }).filter(validRecord);
  }
  function acknowledge(record) {
    var id = record.payload['Sa-Event-Id'];
    confirmedOrders[id] = true;
    delete memoryOrders[id];
    // Store a small receipt without customer details for other open tabs.
    try { localStorage.removeItem(QUEUE_PREFIX + id); } catch (e) {}
    try { localStorage.setItem('sa_order_receipt_v2:' + id, String(Date.now())); } catch (e) {}
    updateRecovery();
  }
  function hasReceipt(record) {
    var id = record.payload['Sa-Event-Id'];
    if (confirmedOrders[id]) return true;
    try { return !!localStorage.getItem('sa_order_receipt_v2:' + id); }
    catch (e) { return false; }
  }
  function orderFingerprint(payload) {
    // Only business fields participate; timestamps and behaviour metrics vary
    // between clicks and must not create a new identity for the same retry.
    return JSON.stringify(['Sa-Name', 'Sa-Phone-Digits', 'Sa-Wilaya', 'Sa-Address',
      'Sa-Product-Name', 'Sa-Variant-Id', 'Sa-Offer', 'Quantity', 'Sa-Unit-Price', 'Sa-Total'
    ].map(function (key) {
      var value = String(payload[key] == null ? '' : payload[key]).trim();
      if (key === 'Sa-Phone-Digits') value = extractDigits(value || payload['Sa-Phone']);
      return value;
    }));
  }
  function recordFor(fd) {
    var payload = {};
    fd.forEach(function (value, key) { payload[key] = String(value); });
    var fingerprint = orderFingerprint(payload);
    if (activeOrder && orderFingerprint(activeOrder.payload) === fingerprint) return activeOrder;
    var existing = getQueue().filter(function (record) {
      return !hasReceipt(record) && orderFingerprint(record.payload) === fingerprint;
    })[0];
    if (existing) return existing;
    return { endpoint: APPS_SCRIPT_URL, createdAt: Date.now(), payload: payload };
  }
  // Preserve old failed submissions when upgrading; malformed entries cannot
  // prevent fresh orders. No automatic replay without customer confirmation.
  (function migrateQueue() {
    try {
      var old = JSON.parse(localStorage.getItem('sa_failed_queue_v1') || '[]');
      if (!Array.isArray(old)) return;
      var allSaved = true;
      old.forEach(function (payload) {
        var record = { endpoint: APPS_SCRIPT_URL, createdAt: payload && payload.__queuedAt || Date.now(), payload: payload };
        if (!validRecord(record)) return;
        var clean = {};
        Object.keys(payload).forEach(function (key) { if (key.indexOf('__') !== 0) clean[key] = payload[key]; });
        record.payload = clean;
        if (!hasReceipt(record) && !saveRecord(record)) allSaved = false;
      });
      if (allSaved) localStorage.removeItem('sa_failed_queue_v1');
    } catch (e) {}
  })();

  function readAcknowledgement(response, record) {
    if (!response || !response.ok) throw new Error('http');
    return response.text().then(function (text) {
      var data;
      try { data = JSON.parse(text); } catch (e) { throw new Error('unconfirmed'); }
      // This is the supplied Apps Script's contract, including errors returned
      // with HTTP 200. Never redirect on a Google error page or an empty reply.
      if (!data || data.result !== 'success' || data.success === false || data.error ||
          (data.eventId && data.eventId !== record.payload['Sa-Event-Id'])) throw new Error('unconfirmed');
      return data;
    });
  }
  function sendOrder(record) {
    var id = record.payload['Sa-Event-Id'];
    if (inFlightOrders[id]) return inFlightOrders[id];
    function transport() {
      if (hasReceipt(record)) return Promise.resolve();
      if (navigator.onLine === false) return Promise.reject(new Error('offline'));
      return new Promise(function (resolve, reject) {
        var controller = typeof AbortController === 'function' ? new AbortController() : null;
        var settled = false;
        var timer = setTimeout(function () {
          settled = true;
          if (controller) controller.abort();
          reject(new Error('timeout'));
        }, REQUEST_TIMEOUT);
        var params = new URLSearchParams();
        Object.keys(record.payload).forEach(function (key) { params.append(key, record.payload[key]); });
        var options = { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: params.toString(), keepalive: true };
        if (controller) options.signal = controller.signal;
        Promise.resolve().then(function () { return fetch(record.endpoint, options); })
          .then(function (response) { return readAcknowledgement(response, record); })
          .then(function () {
            // A late confirmed response is still useful, even after the UI
            // timeout; preserve its receipt instead of inviting another retry.
            acknowledge(record);
            if (!settled) { settled = true; clearTimeout(timer); resolve(); }
          }, function (error) {
            if (!settled) { settled = true; clearTimeout(timer); reject(error); }
          });
      });
    }
    // Coordinate open tabs where Web Locks is supported. Server-side event-ID
    // deduplication is still required for timeouts and older browsers.
    var request = Promise.resolve().then(function () {
      return navigator.locks && navigator.locks.request
        ? navigator.locks.request('cod-order-' + id, { ifAvailable: true }, function (lock) {
          if (!lock) throw new Error('in-progress');
          return transport();
        }) : transport();
    });
    inFlightOrders[id] = request.then(function (result) { delete inFlightOrders[id]; return result; },
      function (error) { delete inFlightOrders[id]; throw error; });
    return inFlightOrders[id];
  }

  function updateRecovery() {
    var product = (form.elements['Sa-Product-Name'] || {}).value;
    recoveryOrder = getQueue().filter(function (record) {
      return !hasReceipt(record) && record.payload['Sa-Product-Name'] === product;
    }).sort(function (a, b) { return b.createdAt - a.createdAt; })[0] || null;
    if ($('formRecoveryStatus')) $('formRecoveryStatus').hidden = !recoveryOrder || formSubmitted;
  }
  function restorePendingOrder() {
    if (!recoveryOrder || formSubmitted) return;
    activeOrder = recoveryOrder;
    var payload = recoveryOrder.payload;
    ['Sa-Name', 'Sa-Phone', 'Sa-Wilaya', 'Sa-Address'].forEach(function (key) {
      if (form.elements[key]) form.elements[key].value = payload[key] || '';
    });
    var savedVariant = variants.filter(function (v) { return String(v.id) === String(payload['Sa-Variant-Id']); })[0];
    if (savedVariant) {
      form.querySelectorAll('input[type=radio][data-option-index]').forEach(function (r) {
        r.checked = savedVariant.options[Number(r.getAttribute('data-option-index'))] === r.value;
      });
      updateVariant(false);
    }
    var savedOffer = Array.from(form.querySelectorAll('input[name="Sa-Offer"]')).filter(function (r) { return r.value === payload['Sa-Offer']; })[0];
    if (savedOffer) { savedOffer.checked = true; applyOffer(); }
    else if (!currentOffer) setQty(parseInt(payload.Quantity, 10) || 1);
    updatePhoneUI(false);
    clearFieldError(form.elements['Sa-Name'], 'nameMessage');
    clearFieldError(wilayaEl, 'wilayaMessage');
    if ($('formRecoveryStatus')) $('formRecoveryStatus').hidden = true;
    scrollToForm();
  }
  if ($('restorePendingOrder')) $('restorePendingOrder').addEventListener('click', restorePendingOrder);
  window.addEventListener('storage', function (event) {
    if (!event.key || event.key.indexOf('sa_pending_order_v2:') === 0 || event.key.indexOf('sa_order_receipt_v2:') === 0) updateRecovery();
  });

  /*********** Thank-you redirect ***********/
  function redirectToThankYou(record) {
    // Customer details go through sessionStorage, NOT the URL: a name/phone in
    // the query string ends up in analytics + ad pixels (Meta flags that as
    // personal data), in the browser history and in shared links.
    var payload = record.payload;
    var order = {
      name: payload['Sa-Name'] || '',
      phone: payload['Sa-Phone-Digits'],
      wilaya: payload['Sa-Wilaya'] || '',
      product: CFG.productTitle || '',
      variant: payload['Sa-Variant'] === 'Default Title' ? '' : payload['Sa-Variant'] || '',
      offer: payload['Sa-Offer'] || '',
      qty: payload.Quantity,
      total: payload['Sa-Total'],
      eventId: payload['Sa-Event-Id']
    };
    try { sessionStorage.setItem('cod_last_order', JSON.stringify(order)); } catch (e) {}
    var destination = new URL(THANKYOU_URL, window.location.href);
    destination.searchParams.set('q', order.qty);
    destination.searchParams.set('t', order.total);
    window.location.href = destination.href;
  }

  var abandonedSent = false, lastDraftHash = '', lastAttemptHash = '';
  function draftHash() {
    return [extractDigits(phoneInput.value), (form.elements['Sa-Name'].value || '').trim(),
      wilayaEl ? wilayaEl.value : '', (form.elements['Sa-Address'].value || '').trim(),
      currentQty, $('SaVariantId').value].join('|');
  }
  function sendAttemptedIfNeeded() {
    if (document.visibilityState === 'hidden' || formSubmitted || activeOrder || !hasPhoneForSending()) return;
    var h = draftHash();
    if (h === lastAttemptHash) return;
    lastAttemptHash = h;
    sendViaBeaconOrKeepalive(buildFD('Attempted'));
  }
  function sendAbandonedLead() {
    if (formSubmitted || activeOrder || abandonedSent || !hasPhoneForSending()) return;
    sendViaBeaconOrKeepalive(buildFD('Abandoned'));
    abandonedSent = true;
  }
  function sendDraftSnapshot() {
    if (document.visibilityState === 'hidden' || formSubmitted || activeOrder || !hasPhoneForSending()) return;
    var h = draftHash();
    if (h === lastDraftHash) return;
    lastDraftHash = h;
    sendViaBeaconOrKeepalive(buildFD('Draft'));
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') focusCount++; else sendAbandonedLead();
  });
  window.addEventListener('pagehide', sendAbandonedLead);
  setInterval(function () {
    if (!formSubmitted && hasPhoneForSending() && Date.now() - lastInteraction > 120000) sendAbandonedLead();
  }, 30000);
  setInterval(sendDraftSnapshot, 25000);

  /*********** Submit ***********/
  function clearFieldError(el, messageId) {
    if (el) { el.classList.remove('is-invalid'); el.removeAttribute('aria-invalid'); }
    if ($(messageId)) $(messageId).hidden = true;
  }
  form.elements['Sa-Name'].addEventListener('input', function () { clearFieldError(this, 'nameMessage'); });
  if (wilayaEl) wilayaEl.addEventListener('change', function () { clearFieldError(this, 'wilayaMessage'); });
  function fail(el, msg) {
    if (el) { el.classList.add('is-invalid'); el.setAttribute('aria-invalid', 'true'); el.focus(); el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    if (msg && el === phoneInput) showPhoneMsg(msg);
    var message = el === wilayaEl ? $('wilayaMessage') : el === form.elements['Sa-Name'] ? $('nameMessage') : null;
    if (message) { message.textContent = msg; message.hidden = false; }
    sendAttemptedIfNeeded();
  }
  function restoreControls() {
    controlsBeforeSubmit.forEach(function (item) { item.el.disabled = item.disabled; });
    controlsBeforeSubmit = [];
    formSubmitted = false;
    form.removeAttribute('aria-busy');
    btn.innerHTML = btnHTML;
    if (variants.length) updateVariant(false);
    else {
      btn.disabled = !initiallyAvailable;
      if (!initiallyAvailable) btn.innerHTML = '<span>هذا المنتج غير متوفر حالياً</span>';
    }
  }
  function networkError(message) {
    $('formNetworkError').textContent = message;
    $('formNetworkError').style.display = 'block';
    if ($('formNetworkHelp')) $('formNetworkHelp').hidden = false;
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (formSubmitted || btn.disabled || form.dataset.codReady !== 'true') return;

    var trap = $('Sa-Bot-Trap');
    if (trap && trap.value) return; // bot

    var nameEl = form.elements['Sa-Name'];
    if (!nameEl.value.trim()) return fail(nameEl, 'أدخل اسمك حتى نتمكن من تأكيد الطلب معك.');
    nameEl.value = nameEl.value.trim();
    clearFieldError(nameEl, 'nameMessage');
    if (!hasPhoneForSending()) { updatePhoneUI(true); return fail(phoneInput); }
    if (wilayaEl && !wilayaEl.value) return fail(wilayaEl, 'اختر ولاية التوصيل من القائمة.');
    clearFieldError(wilayaEl, 'wilayaMessage');

    // Capture before disabling controls (disabled inputs are omitted by FormData).
    var record = recordFor(buildFD('Submitted'));
    var savedLocally = hasReceipt(record) || saveRecord(record);
    activeOrder = record;
    formSubmitted = true;
    controlsBeforeSubmit = Array.from(form.querySelectorAll('input, select, button'), function (el) {
      var item = { el: el, disabled: el.disabled }; el.disabled = true; return item;
    });
    form.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    btn.innerHTML = '<span class="cod-spinner" aria-hidden="true"></span><span>جاري إرسال طلبيتك...</span>';
    $('formNetworkError').style.display = 'none';
    if ($('formNetworkHelp')) $('formNetworkHelp').hidden = true;
    if ($('formRecoveryStatus')) $('formRecoveryStatus').hidden = true;

    sendOrder(record)
      .then(function () {
        submissionConfirmed = true;
        form.removeAttribute('aria-busy');
        btn.innerHTML = '<span>✅ تم إرسال طلبك</span>';
        redirectToThankYou(record);
      })
      .catch(function (error) {
        restoreControls();
        var message = error.message === 'offline'
          ? 'لا يوجد اتصال بالإنترنت. لم يُرسل الطلب بعد. اتصل بالإنترنت ثم اضغط «أطلب الآن».'
          : error.message === 'in-progress'
            ? 'يجري إرسال هذا الطلب في صفحة أخرى مفتوحة. انتظر تأكيدها قبل المحاولة مجدداً.'
            : 'تعذر تأكيد وصول طلبك. معلوماتك ما زالت هنا؛ اضغط «أطلب الآن» للمحاولة مجدداً أو اتصل بنا للتأكد.';
        if (!savedLocally) message += ' لا تغلق هذه الصفحة قبل تأكيد الطلب.';
        networkError(message);
        updateRecovery();
      });
  });

  // Mobile browsers can restore the disabled successful form from BFCache.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    if (submissionConfirmed || !activeOrder || !inFlightOrders[activeOrder.payload['Sa-Event-Id']]) {
      restoreControls();
      submissionConfirmed = false;
      activeOrder = null;
      abandonedSent = false;
      $('formNetworkError').style.display = 'none';
      if ($('formNetworkHelp')) $('formNetworkHelp').hidden = true;
      updateRecovery();
    }
  });

  /*********** Sticky bars ***********/
  var orderSection = $('orderSection');
  var stickyBar = $('stickyBar');
  function scrollToForm() {
    var nameEl = form.elements['Sa-Name'];
    var next = !nameEl.value.trim() ? nameEl : !hasPhoneForSending() ? phoneInput : wilayaEl && !wilayaEl.value ? wilayaEl : btn;
    if (next) next.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { if (next && !next.disabled) next.focus({ preventScroll: true }); }, 450);
  }
  window.scrollToForm = scrollToForm;
  document.querySelectorAll('[data-scroll-to-form]').forEach(function (b) { b.addEventListener('click', scrollToForm); });

  if ('IntersectionObserver' in window) {
    // Keep the shortcut available until the actual submit button is visible.
    if (orderSection && stickyBar) {
      new IntersectionObserver(function (entries) {
        stickyBar.classList.toggle('visible', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(btn);
    }
    // Top title+price bar: once the price has scrolled away
    var head = $('codStickyHead');
    var priceBlock = $('codPriceBlock');
    if (head && priceBlock) {
      new IntersectionObserver(function (entries) {
        var hidden = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        head.classList.toggle('is-visible', hidden);
      }, { threshold: 0 }).observe(priceBlock);
    }
  }

  // Enable submission only after all handlers and recovery paths are ready.
  if (APPS_SCRIPT_URL && typeof fetch === 'function') {
    form.dataset.codReady = 'true';
    if ($('formStartupStatus')) $('formStartupStatus').hidden = true;
    restoreControls();
    updateRecovery();
    updatePhoneUI(false);
  }
})();
